import type { ReactElement } from 'react';
import { styled } from 'styled-components';
import type { Button, IconButton, Link } from '../../common';

export function ProcessStartWizardRowAction(props: {
    actionComponent: ReactElement<typeof Button | typeof Link | typeof IconButton>;
}) {
    return (
        <StyledFormWizardAction>
            <ActionsWrap>{props.actionComponent}</ActionsWrap>
        </StyledFormWizardAction>
    );
}

const StyledFormWizardAction = styled.div`
    order: 2;
    flex: 0 0 41.6667%;
    max-width: 41.6667%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;

    ${({ theme }) => theme.mediaQueries.small} {
        order: 3;
        flex: 0 0 16.6667%;
        max-width: 16.6667%;
    }
`;

const ActionsWrap = styled.div`
    display: flex;
    justify-content: flex-end;

    .secondary {
        padding: 0.375rem 0;
        display: inline-block;
        line-height: 1.5;
    }
`;
